import { render } from "./ContractSettings.vue?vue&type=template&id=22e81cc3&scoped=true"
import script from "./ContractSettings.vue?vue&type=script&lang=js"
export * from "./ContractSettings.vue?vue&type=script&lang=js"

import "./ContractSettings.vue?vue&type=style&index=0&id=22e81cc3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e81cc3"]])

export default __exports__